'use client'

import React from 'react'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { Box, Flex, Text } from '@mantine/core'
import { imageScaleVariants, staggerConfig } from '@/lib/animations'
import { SupportCardData } from '@/types/interfaces/slider-cards'

interface SupportCarouselCardV2Props {
    item: SupportCardData
}

export default function SupportCarouselCardV2({ item }: SupportCarouselCardV2Props) {
    const imageSrc = typeof item.image === 'string' ? item.image : item.image.src

    const cardContent = (
        <Flex
            w={283}
            h={{ base: 340, sm: 350 }}
            direction="column"
            p={24}
            bg="rgba(255, 255, 255, 0.75)"
            style={{ borderRadius: 16 }}
            justify="flex-start"
            gap={64}
        >
            <Box w="100%" h={121} style={{ borderRadius: 12, overflow: 'hidden' }}>
                <motion.img
                    src={imageSrc}
                    alt={item.label}
                    draggable={false}
                    onDragStart={(e) => e.preventDefault()}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: '-200px 0px' }}
                    variants={imageScaleVariants}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', userSelect: 'none' }}
                />
            </Box>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: '-200px 0px' }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: staggerConfig },
                }}
            >
                <Flex direction="column" gap={12} h="100%">
                    <Text
                        component="h3"
                        c="gray.9"
                        m={0}
                        fz="var(--gm-refresh-title-card)"
                        fw={450}
                        lh="var(--gm-refresh-title-card-lh)"
                        lts={-0.28}
                    >
                        {item.label}
                    </Text>
                    <Text component="p" c="gray.6" m={0} size="md" fw={400} lh="130%" lts={-0.32}>
                        {item.description}
                    </Text>
                </Flex>
            </motion.div>
        </Flex>
    )

    if (item.buttonLink) {
        return (
            <Link href={item.buttonLink} style={{ textDecoration: 'none', color: 'inherit' }} draggable={false}>
                {cardContent}
            </Link>
        )
    }

    return cardContent
}
